<template>
  <div class="admin-wrapper">
    <div class="columns">
      <div class="column is-12">
        <section class="hero is-info is-small">
          <div class="hero-body">
            <h1 class="title is-1">Video Creation</h1>
            <h2 class="subtitle">
              24 hour summary of video generation activity
            </h2>
          </div>
        </section>
        <br /><br />
        <!-- Video Creation Stats -->
        <section class="columns stats">
          <div class="column">
            <el-card class="box-card" v-loading="loading.jobCount">
                <p class="subtitle">Created in last 24 hours</p>
              <p class="title">{{ stats.jobCount }}</p>

            </el-card>
          </div>
          <div class="column">
            <el-card class="box-card" v-loading="loading.completedJobs">
               <p class="subtitle">Completed in last 6 hours</p>
              <p class="title">{{ stats.completedJobs.length }}

              </p>

              <div style="font-size:11px; text-align:center; margin-bottom:-15px"> Last video completed at: {{ ( stats.completedJobs.length > 0 ?  stats.completedJobs[0].date_completed: "" )   | moment  }}</div>
            </el-card>
          </div>
          <div class="column">
            <el-card class="box-card" v-loading="loading.pendingJobs">
               <p class="subtitle">Pending</p>
              <p class="title">{{ stats.pendingJobs.length }}</p>

            </el-card>
          </div>
        </section>
        <br />
        <!-- el-button @click="loggingStuff">Log Stuff</el-button> -->

        <!-- Pending Jobs -->
        <h1 class="title">Pending Jobs</h1>
        <el-table
          :data="stats.pendingJobs"
          style="width: 100%"
          align="center"
          v-loading="loading.pendingJobs"
        >
          <el-table-column label="Date Added" width="180">
            <template slot-scope="scope">
              {{ scope.row.date_added | moment }}
            </template>
          </el-table-column>
          <el-table-column label="Owner" width="180">
            <template slot-scope="scope">
              <router-link :to="`/user/${scope.row.owner}`">{{
                scope.row.owner_name
              }}</router-link>
            </template>
          </el-table-column>
           <el-table-column label="Video Duration" width="180">
            <template slot-scope="scope" >
             {{  scope.row | duration }}<br>  <i style=color:red ><small>{{  scope.row | errordetect }} </small></i>
            </template>
          </el-table-column>
          <el-table-column label="status" width="150">
            <template slot-scope="scope">
              {{ scope.row.status }} <br>( {{ scope.row | job_duration_pending }} )
            </template>
          </el-table-column>
          <el-table-column label="Operations" width="270">
            <template slot-scope="scope">
              <el-button size="mini" @click="showUnFinishedJob(scope.row)"
                >View</el-button
              >
                &nbsp; 
              <el-button-group style="margin-top:-2px">
               <el-tooltip class="item" effect="dark" content="Copy JOB ID" placement="top-start">
                    <el-button style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`${scope.row._id}`)"
                    alt=""
                      >J</el-button>
                </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Copy JOB GUID" placement="top-start">
              <el-button style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`'${scope.row.guid}'`)"
                >G</el-button>
              </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Copy JOB USER ID" placement="top-start">
                  <el-button  style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`${scope.row.owner}`)"
                >U</el-button>
              </el-tooltip>
                 <el-tooltip class="item" effect="dark" content="Copy JOB USER EMAIL" placement="top-start">
                  <el-button  style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`${scope.row.owner_name}`)"
                >E</el-button>
              </el-tooltip>
                 </el-button-group> 
                 &nbsp;
              <el-button size="mini" type="danger" @click="cancelJob(scope.row)"
                >Cancel</el-button
              >
             <!--  <el-button
                size="mini"
                type="info"
                @click="retryJob(scope.row)"
                >Retry</el-button
              > -->
            </template>
          </el-table-column> </el-table
        ><br />

        <!-- Failed Jobs -->
        <h1 class="title">Failed Jobs</h1>
        <el-table
          :data="stats.failedJobs"
          style="width: 100%"
          align="center"
          v-loading="loading.failedJobs"
        >
          <el-table-column label="Date Added" width="180">
            <template slot-scope="scope">
              {{ scope.row.date_added | moment }}
            </template>
          </el-table-column>
          <el-table-column label="Owner" width="180">
            <template slot-scope="scope">
              <router-link :to="`/user/${scope.row.owner}`">{{
                scope.row.owner_name
              }}</router-link>
            </template>
          </el-table-column>
           <el-table-column label="Video Duration" width="180">
            <template slot-scope="scope" >
                 {{ scope.row | duration }}<br>  <i style=color:red ><small>{{  scope.row | errordetect }} </small></i>
            </template>
          </el-table-column>
          <el-table-column label="status" width="150">
            <template slot-scope="scope">
              {{ scope.row.status }} <br>( {{ scope.row | job_duration }} )
            </template>
          </el-table-column>
          <el-table-column label="Operations" width="270">
            <template slot-scope="scope">
              <el-button size="mini" @click="showUnFinishedJob(scope.row)"
                >View</el-button
              >
                &nbsp; 
              <el-button-group style="margin-top:-2px">
               <el-tooltip class="item" effect="dark" content="Copy JOB ID" placement="top-start">
                    <el-button style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`${scope.row._id}`)"
                    alt=""
                      >J</el-button>
                </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Copy JOB GUID" placement="top-start">
              <el-button style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`'${scope.row.guid}'`)"
                >G</el-button>
              </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Copy JOB USER ID" placement="top-start">
                  <el-button  style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`${scope.row.owner}`)"
                >U</el-button>
              </el-tooltip>
                 <el-tooltip class="item" effect="dark" content="Copy JOB USER EMAIL" placement="top-start">
                  <el-button  style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`${scope.row.owner_name}`)"
                >E</el-button>
              </el-tooltip>
                 </el-button-group> 
                 &nbsp;
              <el-button
                size="mini"
                type="danger"
                @click="editFailedJob(scope.row)"
                >Discard</el-button
              >
              <el-button
              v-if="!errordetect(scope.row)"
                size="mini"
                type="info"
                @click="retryJob(scope.row)"
                >Retry</el-button
              >
            </template>
          </el-table-column> </el-table
        ><br />

        <!-- Completed Jobs -->
        <h1 class="title">Completed Jobs</h1>
   <!--      <el-button size="mini" type="info" @click="retryJob(scope.row)" disabled
          >Retry</el-button
        > -->

        <el-table
          :data="stats.completedJobs"
          style="width: 100%"
          align="center"
          v-loading="loading.completedJobs"
        >
          <el-table-column label="Date Completed" width="180">
            <template slot-scope="scope">
              {{ scope.row.date_completed | moment }}
            </template>
          </el-table-column>
          <el-table-column label="Owner" width="180">
            <template slot-scope="scope">
              {{ scope.row.owner_name }}
            </template>
          </el-table-column>
          <el-table-column label="Video Duration" width="180">
            <template slot-scope="scope" >
               {{  scope.row | duration }}
            </template>
          </el-table-column>
          <el-table-column label="status" width="150">
            <template slot-scope="scope">
              {{ scope.row.status }}  <br>( {{ scope.row | job_duration }} )
            </template>
          </el-table-column>
          <el-table-column label="Operations" width="270">
            <template slot-scope="scope">
              
              <el-button size="mini" @click="showFinishedJob(scope.row)"
                >View</el-button
              > 
              &nbsp; 
              <el-button-group style="margin-top:-2px">
               <el-tooltip class="item" effect="dark" content="Copy JOB ID" placement="top-start">
                    <el-button style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`${scope.row._id}`)"
                    alt=""
                      >J</el-button>
                </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Copy JOB GUID" placement="top-start">
              <el-button style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`'${scope.row.guid}'`)"
                >G</el-button>
              </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Copy JOB USER ID" placement="top-start">
                  <el-button  style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`${scope.row.owner}`)"
                >U</el-button>
              </el-tooltip>
                 <el-tooltip class="item" effect="dark" content="Copy JOB USER EMAIL" placement="top-start">
                  <el-button  style="padding-left:5px;padding-right:5px" size="mini" @click="copyContent(`${scope.row.owner_name}`)"
                >E</el-button>
              </el-tooltip>
                 </el-button-group> 
                 &nbsp;
              <el-button size="mini" type="danger" @click="editJob(scope.row)"
                >Delete</el-button
              >
           
             <!--  <el-button
                size="mini"
                type="info"
                @click="retryJob(scope.row)"
                disabled
                >Retry</el-button
              > -->
            </template>
          </el-table-column> </el-table
        ><br />
      </div>
      <el-dialog title="Job Details" :visible.sync="jobDetailVisible" :key="jobSelected.guid" >
        <video controls
        v-if="this.view_finished"
        >
          <source
            :src="`https://sls-wavve-out.s3.amazonaws.com/${jobSelected.guid}.mp4`"
            type="video/mp4"
          />
        </video>
        <pre>{{ jobSelected }}</pre>
        <div slot="footer" class="dialog-footer">
          <el-button type="text" @click="jobDetailVisible = false"
            >Dismiss</el-button
          >
          <a
            :href="`https://sls-wavve-out.s3.amazonaws.com/${jobSelected.guid}.mp4`"
            target="_blank"
          >
            <el-button type="primary" class="has-margin-left"
            v-if="this.view_finished"
              >Download Video</el-button
            >
          </a>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import uuid from 'uuid';
import Reports from '@/api/report.service';
import AdminService from '@/api/admin.service';
import '@/style/admin.scss';

let globaltimeout
export default {
  name: 'reports',
  data() {
    return {
      view_finished: false,
      stats: {
        jobCount: 0,
        failedJobs: [],
        pendingJobs: [],
        completedJobs: [],
      },
      loading: {
        jobCount: true,
        failedJobs: true,
        pendingJobs: true,
        completedJobs: true,
      },
      jobDetailVisible: false,
      jobSelected: {},
      me: this.$store.state.user,
    };
  },
  filters: {
    moment: date => moment(date).format('MMMM D, h:mm a'),
    job_duration_pending: (row) => {
      if (row.date_added) {
        const total = (new Date(new Date().getTime() - new Date(row.date_added).getTime()) / 1000)
        // return `${~~total} secs.`;
        return new Date(1000 * total).toISOString().substr(11, 8)
      }
      return 'Not Finished';
    },
    job_duration: (row) => {
      if (row.date_added && row.date_completed) {
        const total = (new Date(row.date_completed).getTime() - new Date(row.date_added).getTime()) / 1000
        // return `${~~total} secs.`;
        return new Date(1000 * total).toISOString().substr(11, 8)
      }
      return 'Not Finished';
    },
    duration: (row) => {
      // return 0;
      if (row.hasOwnProperty('specs') && row.specs.hasOwnProperty('duration')) {
        const total = row.specs.duration;
        return new Date(1000 * total).toISOString().substr(11, 12)
      }
      if (row.hasOwnProperty('specs') && row.specs.end) {
        const total = row.specs.end - row.specs.start;
        return new Date(1000 * total).toISOString().substr(11, 12)
      }
      return '';
    },

    errordetect: (row) => {
      let error = ''
      if (row.hasOwnProperty('specs') && !row.specs.hasOwnProperty('duration')) error += " the json field 'spec.duration' is not present in job  ; "
      else if (!row.hasOwnProperty('specs')) error += " the json field 'spec' is not present in job  ; "
      if (row.hasOwnProperty('specs') && row.specs.hasOwnProperty('duration') && row.specs.duration < 3) error += ' the job duration is lower than 3 seconds  ; '
      if (!row.hasOwnProperty('episodeInfo')) error += " the job does not have a  'episodeInfo' ; "
      return error;
    },


  },
  created() {
    this.getStats();
    this.updateStatus();
  },
  methods: {
      async copyContent(content) {
    try {
      await navigator.clipboard.writeText(content);
      this.$message.success({ message: 'JOB Information copied to clipboard' });
      console.log('Content copied to clipboard');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  },
    errordetect(row) {
      let error = false
      if (row.hasOwnProperty('specs') && !row.specs.hasOwnProperty('duration')) error = true;
      if (row.hasOwnProperty('specs') && row.specs.hasOwnProperty('duration') && row.specs.duration < 3) error = true;
      if (!row.hasOwnProperty('episodeInfo')) error = true;
      return error;
    },
    loggingStuff() {
      console.log('testing-----------------');
      console.log(this.stats.pendingJobs);
    },
    async updateStatus() {
      this.getStats()
      if(window.globaltimeout == undefined) {
          window.globaltimeout = setInterval(async () => {
            this.getStats()
            // .then(() => { this.updateStatus(); });
          }, 20000)
      }
    },
    async getStats() {
      this.stats.jobCount = (await Reports.getJobStats()).count;
      this.loading.jobCount = false;

      this.stats.pendingJobs = await Reports.getPendingJobs();
      this.loading.pendingJobs = false;

      this.stats.failedJobs = await Reports.getFailedJobs();
      this.loading.failedJobs = false;

      this.stats.completedJobs = await Reports.getCompleteJobs();
      this.loading.completedJobs = false;
    },

    showJobOwnerDetail(row) {
      this.$router.push(`/user/${row.owner}`);
    },

    showFinishedJob(row) {
      this.view_finished = true;
      this.jobSelected = row;
      this.jobDetailVisible = true;
    },

    showUnFinishedJob(row) {
      this.view_finished = false;
      this.jobSelected = row;
      this.jobDetailVisible = true;
    },

    async retryJob(row) {
      const confData = {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      };

      try {
        // await this.$confirm('Retry this Job?', 'Warning', confData);
        // row.uuid=uuid.v4();
        row.uuid = row.guid;
        console.log('---------------------', row);
        this.loading.failedJobs = true;
        this.loading.pendingJobs = true;
        await AdminService.retryJob(row._id, row);
        await Promise.all(

          this.stats.failedJobs = await Reports.getFailedJobs(),
          this.loading.failedJobs = false,
          this.stats.pendingJobs = await Reports.getPendingJobs(),
          this.loading.pendingJobs = false,

        )
        this.$message.success({ message: 'Executing: Retry Video job' });
      } catch (err) {
        console.log('--- error retrying video', err);
        this.$message.error({ message: 'Error. Can\'t retry this video job, check console for error details.' });
      }
    },

    async cancelJob(row) {
      const confData = {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      };
      try {
        // await this.$confirm('Cancel this Job?', 'Warning', confData);
        this.loading.failedJobs = true;
        this.loading.pendingJobs = true;
        await AdminService.updateJob(row._id, {
          message: 'canceled by admin.',
          status: 'failed',
        });
        await Promise.all(
          this.stats.failedJobs = await Reports.getFailedJobs(),
          this.loading.failedJobs = false,
          this.stats.pendingJobs = await Reports.getPendingJobs(),
          this.loading.pendingJobs = false,
        )
        this.$message.success({ message: 'Video job canceled' });
      } catch (err) {
        console.log('error', err);
        this.$message.error({ message: 'Error. Video not canceled.' });
      }
    },

    async editJob(row) {
      const confData = {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      };
      try {
        await this.$confirm('Remove this video?', 'Warning', confData);
        await AdminService.updateJob(row._id, {
          message: 'Invalid video or job failed.',
          status: 'Delete Job',
        });
        this.stats.pendingJobs = await Reports.getPendingJobs();
        this.stats.failedJobs = await Reports.getFailedJobs();
        this.$message.success({ message: 'Video job removed' });
      } catch (err) {
        console.log('error', err);
        this.$message.error({ message: 'Error. Video not removed.' });
      }
    },

    async editFailedJob(row) {
      const confData = {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      };
      this.loading.failedJobs = true;

      try {
        // await this.$confirm('Remove this video?', 'Warning', confData);
        await AdminService.updateJob(row._id, {
          message: 'Invalid video or job failed.',
          status: 'Delete Job',
        });
        await Promise.all(
          this.stats.failedJobs = await Reports.getFailedJobs(),
          this.loading.failedJobs = false,
        )
        this.$message.success({ message: 'Video job removed' });
      } catch (err) {
        console.log('error', err);
        this.$message.error({ message: 'Error. Video not removed.' });
      }
    },
  },
};
</script>
